/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

export const indicators = (params, cancelToken = () => {}) => {
    return request({
        url: `/api-tms/indicator/indicators`,
        method: 'get',
        params,
        cancelToken: new request.CancelToken(cancelToken)
    });
};

export default {
    indicators
};